import {$dom} from '../helpers/dom';
import regularPage from '../pages/regular';
import homePage from "../pages/home";
import detailPage from "../pages/detail";
import contactPage from "../pages/contact";
import ordersPage from "../pages/orders";
import orderFormPage from "../pages/order-form";
import catalogPage from "../pages/catalog";
import stockPage from "../pages/stock";
import personalPage from "../pages/personal";
import favouritePage from "../pages/favourites";
import aboutPage from "../pages/about";
import deliveryPage from "../pages/delivery";
import businessPage from "../pages/business";
import reviewPoliticsPage from "../pages/reviewPolitics";

import {isElement} from '../helpers/_utilities';

const pages = [
  regularPage,
  homePage,
  detailPage,
  contactPage,
  ordersPage,
  orderFormPage,
  catalogPage,
  stockPage,
  personalPage,
  favouritePage,
  aboutPage,
  deliveryPage,
  businessPage,
  reviewPoliticsPage,
];

$dom.ready(function() {
  this.currentPage = pages.find(page => isElement(page.rootEl));

  if (Boolean(this.currentPage)) this.currentPage.init()
});
